import apiClient from "../apiClient";

const resource = "appointments";

export default {
    getAll: params => apiClient.get(`${resource}?${params}`),
    search: params => apiClient.get(`${resource}/search?${params}`),
    getDetails: id => apiClient.get(`${resource}/${id}/details`),
    getDoctorAppointments: id => apiClient.get(`${resource}/${id}/doctorAppointments`),
    getDoctors: () => apiClient.get(`${resource}/doctors`),
    getForEdit: id => apiClient.get(`${resource}/${id}`),
    add: payload => apiClient.post(`${resource}`, payload),
    edit: (id, payload) => apiClient.put(`${resource}/${id}`, payload),
    approval: id => apiClient.put(`${resource}/${id}/approval`),
    approvalReview: id => apiClient.put(`${resource}/${id}/approvalReview`),
    
    checkAppointment: params => apiClient.get(`${resource}/checkAppointment?${params}`),
    checkFollowup: params => apiClient.get(`${resource}/checkFollowup?${params}`),
    delete: id => apiClient.delete(`${resource}/${id}`),
   
};
